export default __webpack_public_path__ + "static/media/duet_logo.0d125508.png";